// removed by extract-text-webpack-plugin
module.exports = {"skfoldingcube":"_14Vwe25KZErcqA_rVAL3Mq","skcube":"Hri3AXtezYpoV-pzEkjNI","sk-foldCubeAngle":"nzXGCYAlE-9C7N1TY0YnU","skcube2":"_3wFusbjUWIRr2DT5U6yZgE","skcube3":"_2uH_iqRdIw7yUmB_GLdZo5","skcube4":"_1DhrwHUR6hqVc3z9MDRqcU"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Spinner/FoldingCube/style.css
// module id = 1352
// module chunks = 0